/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Edit_TitleInputs */

const cs_task_edit_title = /** @type {(inputs: Task_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit úkol`)
};

const en_task_edit_title = /** @type {(inputs: Task_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit task`)
};

/**
* | output |
* | --- |
* | "Edit task" |
*
* @param {Task_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const task_edit_title = /** @type {((inputs?: Task_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_edit_title(inputs)
	return cs_task_edit_title(inputs)
});